import * as React from "react";

export function Watch() {
  return (
    <svg width="16" height="16" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.52 8.01333H7.49333V7H6V4.49333H4.98667V7.48L5.52 8.01333ZM3.49333 2.68C2.71111 3.10667 2.08889 3.71111 1.62667 4.49333C1.2 5.27555 0.986667 6.11111 0.986667 7C0.986667 7.88889 1.2 8.72444 1.62667 9.50667C2.08889 10.2889 2.71111 10.8933 3.49333 11.32V13.5067L4.02667 13.9867H8.02667L8.50667 13.5067V11.32C9.28889 10.8933 9.89333 10.2889 10.32 9.50667C10.7822 8.72444 11.0133 7.88889 11.0133 7C11.0133 6.11111 10.7822 5.27555 10.32 4.49333C9.89333 3.71111 9.28889 3.10667 8.50667 2.68V0.493333L8.02667 0.0133333H4.02667L3.49333 0.493333V2.68ZM10 7C10 7.71111 9.82222 8.38667 9.46667 9.02667C9.11111 9.63111 8.61333 10.1111 7.97333 10.4667C7.36889 10.8222 6.71111 11 6 11C5.28889 11 4.61333 10.8222 3.97333 10.4667C3.36889 10.1111 2.88889 9.63111 2.53333 9.02667C2.17778 8.38667 2 7.71111 2 7C2 6.28889 2.17778 5.63111 2.53333 5.02667C2.88889 4.38667 3.36889 3.88889 3.97333 3.53333C4.61333 3.17778 5.28889 3 6 3C6.71111 3 7.36889 3.17778 7.97333 3.53333C8.61333 3.88889 9.11111 4.38667 9.46667 5.02667C9.82222 5.63111 10 6.28889 10 7Z"
        fill="var(--vscode-editor-foreground, #CCCCCC)"
      />
    </svg>
  );
}

export function Setting() {
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">
      <path
        d="M1783 988v18q0 9 1 18v18q0 9-1 18l259 161-159 383-297-68q-24 26-50 50l68 297-383 159-161-259h-18q-9 0-18 1h-18q-9 0-18-1l-161 259-383-159 68-297q-26-24-50-50l-297 68L6 1221l259-161v-18q0-9-1-18v-18q0-9 1-18L6 827l159-383 297 68q24-26 50-50l-68-297L827 6l161 259h18q9 0 18-1h18q9 0 18 1L1221 6l383 159-68 297q26 24 50 50l297-68 159 383-259 161zm-117 130q2-24 4-47t2-48q0-23-2-47t-4-47l236-147-86-208-271 63q-31-38-63-70t-71-64l63-271-208-86-148 236q-23-2-47-4t-47-2q-24 0-47 2t-48 4L782 146l-208 86 63 271q-38 31-70 63t-64 71l-271-63-86 208 236 148q-2 24-4 47t-2 48q0 23 2 47t4 47l-236 147 86 208 271-63q31 38 63 70t71 64l-63 271 208 86 148-236q23 2 47 4t47 2q24 0 47-2t48-4l147 236 208-86-63-271q38-31 70-63t64-71l271 63 86-208-236-148zm-642-470q78 0 146 29t120 81 80 119 30 147q0 78-29 146t-81 120-119 80-147 30q-78 0-146-29t-120-81-80-119-30-147q0-78 29-146t81-120 119-80 147-30zm0 640q55 0 103-20t84-57 56-84 21-103q0-55-20-103t-57-84-84-56-103-21q-55 0-103 20t-84 57-56 84-21 103q0 55 20 103t57 84 84 56 103 21z"
        fill="var(--vscode-editor-foreground, #CCCCCC)"
      />
    </svg>
  );
}

export function Chevron() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
        fill="var(--vscode-editor-foreground, #CCCCCC)"
      />
    </svg>
  );
}

export function ExternalLink() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
      <path
        d="M 3 3 L 3 21 L 21 21 L 21 12 L 19 12 L 19 19 L 5 19 L 5 5 L 12 5 L 12 3 L 3 3 z M 14 3 L 14 5 L 17.585938 5 L 8.2929688 14.292969 L 9.7070312 15.707031 L 19 6.4140625 L 19 10 L 21 10 L 21 3 L 14 3 z"
        fill="var(--vscode-banner-iconForeground, #3794FF)"
      />
    </svg>
  );
}
